// Libs
import React, { Component } from 'react'
import { Container, Row, Col } from '../../components/Elemental'

//Containers
import Feature from '../Feature'

// CSS
import "./styles.scss"

class Deauth extends Component {
  render() {
    const { children } = this.props

    return (
      <div className="deauth">
        <div className="deauth__page">
          {children}
        </div>
        <div className="deauth__image">
          <Feature />
        </div>
      </div>
    )
  }
}

export default Deauth
